// const api="http://18.162.151.36:8080/api";

const api="https://adminapi.555mix.com/api";

// const api="http://192.168.1.4:8080/api"
// const api="http://18.166.215.128:8080/api"
// const api="http://localhost:8080/api"

export default api;